import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinbanerpune() {



    const cardData = {

keyword: "Cab Service in Baner Pune",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Baner Pune for daily commuters, IT professionals, families, and business travelers. We provide quick local rides, airport transfers, railway station drops, and comfortable outstation travel from Baner to all major destinations. Our fleet includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional and verified chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, Rising Cab Service ensures a safe, smooth, and hassle-free travel experience in Baner and nearby areas.",

topPlaces: [
    {
        title: "Alibaug",
        description:
            " is a coastal town near Mumbai known for clean beaches, sea forts, and relaxing weekend trips from Pune."
    },
    {
        title: "Matheran",
        description:
            " is an eco-friendly hill station where vehicles are banned, famous for toy train rides, viewpoints, and forest trails."
    },
    {
        title: "Lonavala",
        description:
            " is one of the most popular weekend getaways from Pune, known for lush green valleys, waterfalls, caves, and scenic monsoon views."
    },
    {
        title: "Khandala",
        description:
            " is a small hill station near Lonavala famous for misty mountains, viewpoints, and short scenic drives from Pune."
    },
    {
        title: "Lavasa",
        description:
            " is a planned hill city near Pune with lakeside promenades, colorful buildings, and leisure activities ideal for a quick getaway."
    },
    {
        title: "Mahabaleshwar",
        description:
            " is a famous hill station known for strawberry farms, viewpoints, waterfalls, and cool weather throughout the year."
    },
    {
        title: "Panchgani",
        description:
            " is a peaceful hill station near Mahabaleshwar known for Table Land plateau, scenic valleys, and calm holiday stays."
    },
    
    {
        title: "Bhimashankar",
        description:
            " is a famous Jyotirlinga temple located in the Western Ghats, surrounded by dense forest and trekking routes."
    },
    {
        title: "Tapola",
        description:
            " is often called the ‘Mini Kashmir of Maharashtra’ and is known for boating, lake views, and peaceful nature surroundings near Mahabaleshwar."
    },
    {
        title: "Kolad",
        description:
            " is a popular adventure destination near Pune known for white water rafting on the Kundalika River and camping experiences."
    }
],



services: [
    {
        name: "Taxi Service in Baner Pune",
        description:
            "Rising Cab Service offers Taxi Service in Baner Pune for daily commuters, families, corporate travelers, and tourists looking for safe, reliable, and comfortable transportation. We provide well-maintained AC vehicles, professional drivers, and 24x7 availability for local travel, airport transfers, and outstation trips. Our service ensures punctual pickups, smooth rides, and affordable fares for all types of travel needs across Baner and Pune city."
    },
    {
        name: "Baner Cab Service",
        description:
            "Our Baner Cab Service is designed to provide quick, safe, and comfortable transportation for residents, IT professionals, and business travelers. Rising Cab Service ensures clean vehicles, experienced chauffeurs, and flexible booking options for daily commuting, airport transfers, and intercity travel with complete reliability and customer satisfaction."
    },
    {
        name: "Baner Taxi Service",
        description:
            "Rising Cab Service provides Baner Taxi Service with well-maintained cars and professional drivers for hassle-free travel across Pune and Maharashtra. Whether it is a short city ride or a long-distance journey, we ensure safe driving, timely service, and affordable pricing for all passengers."
    },
    {
        name: "Best Cab Service in Baner",
        description:
            "Book Best Cab Service in Baner with Rising Cab Service for premium quality transportation, transparent pricing, and 24x7 customer support. We focus on providing safe, comfortable, and reliable rides with a wide range of vehicles suitable for families, corporate clients, and solo travelers."
    },
    {
        name: "Online Cab Booking Baner",
        description:
            "Our Online Cab Booking Baner system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for local and outstation travel needs with reliable service and fast response time."
    },
    {
        name: "Cab Hire in Baner Pune",
        description:
            "Rising Cab Service offers Cab Hire in Baner Pune for hourly rentals, full-day packages, corporate travel, and personal transportation needs. Our flexible hire options come with professional drivers and comfortable vehicles to ensure a smooth and stress-free travel experience."
    },
    {
        name: "Taxi Booking Baner",
        description:
            "Book Taxi Booking Baner with Rising Cab Service for fast, reliable, and affordable transportation. We provide clean vehicles, experienced drivers, and on-time service for all types of travel including local rides, airport transfers, and outstation trips."
    },
    {
        name: "Baner to Pune Airport Cab",
        description:
            "Rising Cab Service offers Baner to Pune Airport Cab with punctual pickup, comfortable AC vehicles, and professional drivers ensuring a smooth and stress-free airport transfer experience at any time of the day or night."
    },
    {
        name: "Baner to Mumbai Cab",
        description:
            "Our Baner to Mumbai Cab service provides safe and comfortable intercity travel with experienced drivers, flexible timing, and well-maintained vehicles ideal for business trips, family travel, and weekend journeys."
    },
    {
        name: "Baner to Shirdi Cab",
        description:
            "Rising Cab Service offers Baner to Shirdi Cab for a peaceful pilgrimage to Sai Baba temple with comfortable vehicles, professional drivers, and hassle-free travel arrangements for families and devotees."
    },
    {
        name: "Baner to Nashik Cab",
        description:
            "Book Baner to Nashik Cab with Rising Cab Service for safe and comfortable travel to one of Maharashtra’s major spiritual and wine tourism destinations with flexible booking options."
    },
    {
        name: "Baner to Goa Cab",
        description:
            "Rising Cab Service provides Baner to Goa Cab for a relaxing beach vacation with safe driving, clean vehicles, and experienced chauffeurs ensuring a smooth long-distance journey."
    },
    {
        name: "Baner to Mahabaleshwar Cab",
        description:
            "Our Baner to Mahabaleshwar Cab service offers scenic hill station travel with comfortable rides, professional drivers, and flexible travel schedules for families and couples."
    },
    {
        name: "Baner to Lonavala Cab",
        description:
            "Rising Cab Service provides Baner to Lonavala Cab for quick weekend getaways with safe, affordable, and comfortable transportation options."
    },
    {
        name: "Baner to Kolhapur Cab",
        description:
            "Book Baner to Kolhapur Cab with Rising Cab Service for pilgrimage and family travel with reliable drivers and comfortable intercity transportation."
    },
    {
        name: "Baner to Pune Darshan Cab",
        description:
            "Rising Cab Service offers Baner to Pune Darshan Cab for sightseeing tours covering famous temples, historical sites, and tourist attractions across Pune city."
    },
    {
        name: "Baner to Bhimashankar Cab",
        description:
            "Our Baner to Bhimashankar Cab service ensures safe pilgrimage travel to the Jyotirlinga temple with experienced drivers and comfortable vehicles for a peaceful journey."
    },
    {
        name: "Baner to Pandharpur Cab",
        description:
            "Rising Cab Service provides Baner to Pandharpur Cab for devotees visiting Lord Vitthal temple with reliable service, flexible timings, and comfortable travel options."
    },
    {
        name: "Innova Crysta on Rent in Baner",
        description:
            "Book Innova Crysta on Rent in Baner with Rising Cab Service for premium comfort, spacious seating, and luxury travel experience ideal for family and group trips."
    },
    {
        name: "Ertiga Cab Service Baner",
        description:
            "Rising Cab Service offers Ertiga Cab Service Baner for affordable and comfortable family travel with clean vehicles and professional drivers for local and outstation trips."
    },
    {
        name: "Swift Dzire Cab Service Baner",
        description:
            "Our Swift Dzire Cab Service Baner provides economical and comfortable rides ideal for daily commuting, city travel, and short-distance trips."
    },
    {
        name: "Sedan Cab Service Baner",
        description:
            "Rising Cab Service offers Sedan Cab Service Baner for budget-friendly and comfortable travel with well-maintained cars and experienced drivers."
    },
    {
        name: "SUV Cab Service Baner",
        description:
            "Book SUV Cab Service Baner for spacious and comfortable travel suitable for families, groups, and long-distance journeys with safe driving and reliable service."
    },
    {
        name: "Luxury Car Rental Baner",
        description:
            "Rising Cab Service provides Luxury Car Rental Baner for premium travel experiences with high-end vehicles, professional chauffeurs, and elegant comfort for special occasions and corporate travel."
    },
    {
        name: "Innova Cab Service Baner",
        description:
            "Our Innova Cab Service Baner ensures comfortable group travel with spacious seating, smooth rides, and reliable intercity transportation."
    },
    {
        name: "Kia Carens Cab Service Baner",
        description:
            "Rising Cab Service offers Kia Carens Cab Service Baner for modern, comfortable, and safe family travel with professional drivers and clean vehicles."
    },
    {
        name: "Book Cab in Baner Now",
        description:
            "Book Cab in Baner Now with Rising Cab Service for instant confirmation, quick pickups, and reliable transportation for all travel needs."
    },
    {
        name: "Instant Taxi Booking Baner",
        description:
            "Our Instant Taxi Booking Baner service ensures fast cab availability with easy booking, transparent pricing, and quick response time."
    },
    {
        name: "Trusted Cab Service Baner",
        description:
            "Rising Cab Service is a Trusted Cab Service Baner known for safety, reliability, professional drivers, and high-quality customer service."
    },
    {
        name: "Cab Service Near High Street Baner",
        description:
            "Book Cab Service Near High Street Baner for quick pickups and convenient travel for shopping, dining, and local commuting needs."
    },
    {
        name: "Taxi Service Near Sus Road Baner",
        description:
            "Rising Cab Service provides Taxi Service Near Sus Road Baner with fast availability, safe rides, and comfortable travel options."
    },
    {
        name: "Cab Service Near Balewadi Stadium",
        description:
            "Our Cab Service Near Balewadi Stadium ensures reliable transportation for events, matches, and daily travel with professional drivers and clean vehicles."
    }
],

tableData: [
    ["Taxi Service in Baner Pune", "Baner Cab Service"],
    ["Baner Taxi Service", "Best Cab Service in Baner"],
    ["Online Cab Booking Baner", "Cab Hire in Baner Pune"],
    ["Taxi Booking Baner", "Baner to Pune Airport Cab"],
    ["Baner to Mumbai Cab", "Baner to Shirdi Cab"],
    ["Baner to Nashik Cab", "Baner to Goa Cab"],
    ["Baner to Mahabaleshwar Cab", "Baner to Lonavala Cab"],
    ["Baner to Kolhapur Cab", "Baner to Pune Darshan Cab"],
    ["Baner to Bhimashankar Cab", "Baner to Pandharpur Cab"],
    ["Innova Crysta on Rent in Baner", "Ertiga Cab Service Baner"],
    ["Swift Dzire Cab Service Baner", "Sedan Cab Service Baner"],
    ["SUV Cab Service Baner", "Luxury Car Rental Baner"],
    ["Innova Cab Service Baner", "Kia Carens Cab Service Baner"],
    ["Book Cab in Baner Now", "Instant Taxi Booking Baner"],
    ["Trusted Cab Service Baner", "Cab Service Near High Street Baner"],
    ["Taxi Service Near Sus Road Baner", "Cab Service Near Balewadi Stadium"]
],





whychoose: [
    {
        WhyChooseheading: "Dependable Transportation Across Baner",
        WhyChoosedescription: "Rising Cab Service provides reliable cab services for residents, working professionals, students, and visitors traveling within Baner and surrounding areas."
    },
    {
        WhyChooseheading: "Ideal for IT and Corporate Professionals",
        WhyChoosedescription: "Business travelers and employees working in Baner, Balewadi, Hinjewadi, Aundh, and nearby commercial hubs can enjoy timely and convenient transportation."
    },
    {
        WhyChooseheading: "Easy Travel for Local and Outstation Trips",
        WhyChoosedescription: "Whether planning a local ride, airport transfer, business visit, weekend getaway, or long-distance journey, we offer suitable travel solutions."
    },
    {
        WhyChooseheading: "Vehicle Choices for Every Requirement",
        WhyChoosedescription: "Customers can select from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles depending on their travel needs."
    },
    {
        WhyChooseheading: "Convenient Pickup from Homes and Offices",
        WhyChoosedescription: "Our cab service covers residential societies, office complexes, hotels, restaurants, hospitals, and major landmarks throughout Baner."
    },
    {
        WhyChooseheading: "Travel Solutions Tailored to Your Schedule",
        WhyChoosedescription: "From early morning airport transfers to late-night pickups, we help customers plan journeys according to their preferred timing."
    },
    {
        WhyChooseheading: "Clean Vehicles with Professional Drivers",
        WhyChoosedescription: "Every trip is supported by experienced drivers and well-maintained vehicles to provide a pleasant and secure travel experience."
    },
    {
        WhyChooseheading: "Preferred by Families and Frequent Travelers",
        WhyChoosedescription: "Our services are widely chosen for family outings, business travel, sightseeing tours, and regular transportation requirements."
    }
]
};

const faqData = [
    {
        question: "What makes Baner a popular location for cab services?",
        answer: "Baner is a major residential and commercial area with excellent connectivity to Hinjewadi, Balewadi, Aundh, Wakad, and Pune city."
    },
    {
        question: "Are airport transfers available from Baner?",
        answer: "Yes, travelers can schedule convenient pickup and drop services between Baner and Pune Airport."
    },
    {
        question: "Can office commuters arrange daily transportation?",
        answer: "Yes, regular travel solutions are available for employees working in IT parks and business centers."
    },
    {
        question: "Which nearby destinations are frequently booked from Baner?",
        answer: "Popular routes include Hinjewadi, Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, and Pune Airport."
    },
    {
        question: "What vehicle categories are available for booking?",
        answer: "Customers can choose from Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and larger group vehicles."
    },
    {
        question: "Is advance reservation recommended for weekends?",
        answer: "Yes, advance booking helps ensure vehicle availability during weekends, holidays, and peak travel periods."
    },
    {
        question: "Can large families hire bigger vehicles?",
        answer: "Yes, spacious vehicles and Tempo Travellers are available for family functions, tours, and group travel."
    },
    {
        question: "Do you provide transportation for corporate meetings and events?",
        answer: "Yes, many professionals use our service for business meetings, conferences, and corporate travel requirements."
    },
    {
        question: "Are round-trip travel options available?",
        answer: "Yes, customers can choose one-way rides or round-trip packages based on their itinerary."
    },
    {
        question: "How can customers schedule a cab from Baner?",
        answer: "Reservations can be made through phone calls, WhatsApp messages, or online booking inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ketan Joshi",
        feedback:
            "Frequent business travel from Baner has become much more convenient after choosing Rising Cab Service. The punctuality and professionalism have always been impressive.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rucha Patil",
        feedback:
            "A recent outstation family trip was handled exceptionally well. Comfortable seating, smooth driving, and excellent coordination made the journey enjoyable for everyone.",
        rating: 5
    }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Baner Pune",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-baner-pune.jpg",
"description": "Book Cab Service in Baner Pune with Rising Cab Service for local travel, airport transfers, and outstation trips. Enjoy safe, affordable, and reliable taxi service in Baner with AC cars and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-baner-pune"
}
};





    return (
        <div>

<Helmet>
  <title>Cab Service in Baner Pune | Local & Airport Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Baner Pune for local rides, airport transfers, and outstation travel. Affordable taxi service with AC cabs and professional drivers for safe and comfortable journeys."
/>

<meta
 name="keywords"
 content="Taxi Service in Baner Pune, Baner Cab Service, Baner Taxi Service, Best Cab Service in Baner, Online Cab Booking Baner"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinbanerpune;